import { isBooleanControl, RankedTester, rankWith } from "@jsonforms/core";
import React from "react";

export const HiddenFieldViewRenderer = () => {
  return <></>;
};

export const hiddenFieldViewTester: RankedTester = rankWith(
  1,
  isBooleanControl,
);
